import React, { useState } from 'react';
import axios from 'axiosInstance';
import { Container, Row, Col, Button, Alert } from 'react-bootstrap';
import '../css/AuthLogin.css'; 

const Verify = () => {
  const [message, setMessage] = useState({ text: '', variant: '' });
  const [isLoading, setIsLoading] = useState(false);

  // Recupera el email guardado en sessionStorage
  const email = sessionStorage.getItem('registeredEmail');

  const handleResend = async () => {
    if (!email) {
      setMessage({ text: 'No se encontró el correo registrado.', variant: 'danger' });
      return;
    }

    setIsLoading(true);
    setMessage({ text: '', variant: '' });

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_URL + '/api/auth/resend-verification-email',
        { email },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 204) {
        setMessage({ text: 'No se encontró ninguna cuenta con ese correo.', variant: 'danger' });
      } else {
        setMessage({ text: 'Correo de verificación reenviado con éxito.', variant: 'success' });
      }
    } catch (error) {
      setMessage({ text: 'Hubo un error al reenviar el correo.', variant: 'danger' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="mt-5 text-center">
      <Row className="justify-content-center">
        <Col md={6}>
          <h2 className='Titulo'>Verifica tu cuenta</h2>
          <p>Te hemos enviado un correo de verificación a:</p>
          <p><strong>{email || 'No hay correo registrado'}</strong></p>

          {message.text && (
            <Alert variant={message.variant} className="mt-3">
              {message.text}
            </Alert>
          )}

          <Button
            className='boton_accion_user w-100'
            onClick={handleResend}
            disabled={isLoading || !email}
          >
            {isLoading ? 'Enviando...' : 'Reenviar correo de verificación'}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Verify;
